<template>
  <div class="container">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>PO管理</el-breadcrumb-item>
        <el-breadcrumb-item>开发测试</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card class="box-card">
      <p class="page-desc">临时测试入口，手动输入地址访问。后续各类测试接口可在此页追加按钮。</p>

      <div class="action-list">
        <div v-for="item in testActions" :key="item.key" class="action-item">
          <div class="action-info">
            <div class="action-title">{{ item.label }}</div>
            <div class="action-desc">{{ item.desc }}</div>
          </div>
          <el-button
            type="primary"
            :loading="loadingKey === item.key"
            @click="handleRun(item)"
          >
            执行
          </el-button>
        </div>
      </div>

      <div class="result-panel">
        <div class="result-title">执行结果</div>
        <pre class="result-text">{{ displayText }}</pre>
      </div>
    </el-card>
  </div>
</template>

<script>
import { voiceNoticeRobotScan } from '@/api/auto_dispatch';

export default {
  name: 'DevTestPage',
  data() {
    return {
      loadingKey: '',
      displayText: '点击上方按钮执行测试，结果将显示在此处。',
      testActions: [
        {
          key: 'voiceNoticeScan',
          label: '语音通知停机扫描',
          desc: '扫描近 7 天内仍为停机的号码并推送企微；若号码有更近的非停机记录则跳过。',
          run: () => voiceNoticeRobotScan({}),
        },
        // 后续临时测试接口在此追加 { key, label, desc, run }
      ],
    };
  },
  methods: {
    async handleRun(item) {
      this.loadingKey = item.key;
      this.displayText = `正在执行：${item.label} ...`;
      try {
        const response = await item.run();
        const body = response.data || {};
        const text = (body.data && body.data.displayText) || body.displayText;
        if (text) {
          this.displayText = text;
          this.$message.success('执行完成');
        } else {
          this.displayText = body.msg || JSON.stringify(body, null, 2);
          this.$message.warning(body.msg || '执行完成，但未返回展示文本');
        }
      } catch (error) {
        const detail = error.response && error.response.data && error.response.data.detail;
        this.displayText = `执行失败\n\n${detail || error.message || '未知错误'}`;
        this.$message.error('执行失败');
        console.error(error);
      } finally {
        this.loadingKey = '';
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}
.box-card {
  margin-top: 16px;
}
.page-desc {
  margin-bottom: 24px;
  color: #909399;
  font-size: 14px;
}
.action-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.action-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}
.action-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}
.action-desc {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}
.result-panel {
  margin-top: 24px;
}
.result-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}
.result-text {
  margin: 0;
  padding: 16px;
  min-height: 200px;
  background: #1e1e1e;
  color: #d4d4d4;
  font-size: 14px;
  line-height: 1.8;
  font-family: Consolas, 'Courier New', monospace;
  white-space: pre-wrap;
  word-break: break-word;
  border-radius: 4px;
  overflow: auto;
}
</style>
